import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "להכיר בדפוס בלי להאשים את עצמי",
    opening: localizedGenderNode(
      [
      "היום אני לא שופט את עצמי. אני מזהה דפוס — ונשאר איתי."
    ],
      [
      "היום אני לא שופט את עצמי. אני מזהה דפוס — ונשאר איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה דפוס. לא פגם באופי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה דפוס. לא פגם באופי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "לאיזה סוג של אנשים אני נמשך/ת שוב ושוב, למרות שכואב לי שם?\n[כאן אני כותב]",
      "מה משותף לקשרים האלה בדיעבד?\n[כאן אני כותב]",
      "מה אני מרגיש/ה עכשיו כשאני רואה את זה על הדף?\n[כאן אני כותב]"
    ],
      [
      "לאיזה סוג של אנשים אני נמשך/ת שוב ושוב, למרות שכואב לי שם?\n[כאן אני כותב]",
      "מה משותף לקשרים האלה בדיעבד?\n[כאן אני כותב]",
      "מה אני מרגיש/ה עכשיו כשאני רואה את זה על הדף?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "דפוס נולד מכאב ישן. היום אני רק רואה אותו."
    ],
      [
      "סגירה",
      "דפוס נולד מכאב ישן. היום אני רק רואה אותו."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט אחד: “אני לומד/ת להכיר את עצמי, לא להאשים.”",
      "אני כותב/ת משפט אחד: “אני לומד/ת להכיר את עצמי, לא להאשים.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע שבו זה מרגיש “מוכר”",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את תחושת ה“בית” שמטעה אותי."
    ],
      [
      "היום אני מזהה את תחושת ה“בית” שמטעה אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי בקשר מתחילה תחושת המשיכה החזקה?\n[כאן אני כותב]",
      "איך ה“מוכר” הזה מרגיש בגוף?\n[כאן אני כותב]",
      "מה אני נוטה לפרש בטעות כאהבה?\n[כאן אני כותב]"
    ],
      [
      "מתי בקשר מתחילה תחושת המשיכה החזקה?\n[כאן אני כותב]",
      "איך ה“מוכר” הזה מרגיש בגוף?\n[כאן אני כותב]",
      "מה אני נוטה לפרש בטעות כאהבה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מוכר לא תמיד אומר בטוח."
    ],
      [
      "סגירה",
      "מוכר לא תמיד אומר בטוח."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה תחושת “קליק” חזק — נשימה אחת + שאלה: “זה מוכר או זה טוב לי?”",
      "כשעולה תחושת “קליק” חזק — נשימה אחת + שאלה: “זה מוכר או זה טוב לי?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה אני מאני בוחר לתקן דרך הקשר",
    opening: localizedGenderNode(
      [
      "היום אני בודק מה אני מנסה לרפא דרך אחרים."
    ],
      [
      "היום אני בודק מה אני מנסה לרפא דרך אחרים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה כאב ישן מתעורר בקשרים האלה?\n[כאן אני כותב]",
      "מה אני מקווה שיקרה הפעם “סוף-סוף”?\n[כאן אני כותב]",
      "מה אני מנסה להוכיח על עצמי?\n[כאן אני כותב]"
    ],
      [
      "איזה כאב ישן מתעורר בקשרים האלה?\n[כאן אני כותב]",
      "מה אני מקווה שיקרה הפעם “סוף-סוף”?\n[כאן אני כותב]",
      "מה אני מנסה להוכיח על עצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קשר לא נועד לתקן פצע — אלא לפגוש אדם שלם."
    ],
      [
      "סגירה",
      "קשר לא נועד לתקן פצע — אלא לפגוש אדם שלם."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת את המשפט: “אני לא בוחר/ת/ה להוכיח ערך דרך כאב.”",
      "אני כותב/ת את המשפט: “אני לא בוחר/ת/ה להוכיח ערך דרך כאב.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "ההבדל בין עוצמה לאינטימיות",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין דרמה לבין חיבור."
    ],
      [
      "היום אני מפריד בין דרמה לבין חיבור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך נראית “עוצמה” בקשרים שלי?\n[כאן אני כותב]",
      "איפה אין באמת הקשבה, יציבות, ביטחון?\n[כאן אני כותב]",
      "איך מרגישה אינטימיות שקטה בעיניי?\n[כאן אני כותב]"
    ],
      [
      "איך נראית “עוצמה” בקשרים שלי?\n[כאן אני כותב]",
      "איפה אין באמת הקשבה, יציבות, ביטחון?\n[כאן אני כותב]",
      "איך מרגישה אינטימיות שקטה בעיניי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא כל רגש חזק הוא אהבה."
    ],
      [
      "סגירה",
      "לא כל רגש חזק הוא אהבה."
    ]
    ),
    action: localizedGenderNode(
      "היום אני שם לב לרגע אחד של שקט — ולא בורח ממנו.",
      "היום אני שם לב לרגע אחד של שקט — ולא בורח ממנו."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד מיציבות",
    opening: localizedGenderNode(
      [
      "היום אני בודק אם שקט מפחיד אותי."
    ],
      [
      "היום אני בודק אם שקט מפחיד אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מרגיש/ה מול אדם יציב?\n[כאן אני כותב]",
      "מה מפחיד אותי בקשר רגוע?\n[כאן אני כותב]",
      "איזה סיפור אני מספר/ת לעצמי על שקט?\n[כאן אני כותב]"
    ],
      [
      "איך אני מרגיש/ה מול אדם יציב?\n[כאן אני כותב]",
      "מה מפחיד אותי בקשר רגוע?\n[כאן אני כותב]",
      "איזה סיפור אני מספר/ת לעצמי על שקט?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שקט לא אומר ריק. לפעמים הוא ביטחון."
    ],
      [
      "סגירה",
      "שקט לא אומר ריק. לפעמים הוא ביטחון."
    ]
    ),
    action: localizedGenderNode(
      "אני נשאר/ת עוד דקה אחת במקום שלא “מרגש”.",
      "אני נשאר/ת עוד דקה אחת במקום שלא “מרגש”."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "גבולות שנשברים מוקדם",
    opening: localizedGenderNode(
      [
      "היום אני רואה מתי אני מוותר/ת על עצמי."
    ],
      [
      "היום אני רואה מתי אני מוותר/ת על עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "באיזה שלב בקשר אני מתחיל/ה לוותר על גבול?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם אשמור עליו?\n[כאן אני כותב]",
      "מה זה עושה לי בדיעבד?\n[כאן אני כותב]"
    ],
      [
      "באיזה שלב בקשר אני מתחיל/ה לוותר על גבול?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם אשמור עליו?\n[כאן אני כותב]",
      "מה זה עושה לי בדיעבד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "משיכה שלא מכבדת גבולות — פוגעת."
    ],
      [
      "סגירה",
      "משיכה שלא מכבדת גבולות — פוגעת."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת גבול אחד שהיה חשוב לי בעבר.",
      "אני כותב/ת גבול אחד שהיה חשוב לי בעבר."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "דפוס רודף-נמנע (אם קיים)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה תנועה אוטומטית."
    ],
      [
      "היום אני מזהה תנועה אוטומטית."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "האם אני נמשך/ת למי שמתרחק/ת?\n[כאן אני כותב]",
      "מה קורה לי כשהצד השני לא זמין רגשית?\n[כאן אני כותב]",
      "איזה תפקיד אני לוקח/ת שם?\n[כאן אני כותב]"
    ],
      [
      "האם אני נמשך/ת למי שמתרחק/ת?\n[כאן אני כותב]",
      "מה קורה לי כשהצד השני לא זמין רגשית?\n[כאן אני כותב]",
      "איזה תפקיד אני לוקח/ת שם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "דפוס הוא תנועה — לא זהות."
    ],
      [
      "סגירה",
      "דפוס הוא תנועה — לא זהות."
    ]
    ),
    action: localizedGenderNode(
      "כשמישהו מתרחק — אני לא רודף/ת מיד. נשימה.",
      "כשמישהו מתרחק — אני לא רודף/ת מיד. נשימה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מה אני מרגיש/ה על עצמי בתוך הקשר",
    opening: localizedGenderNode(
      [
      "היום אני בודק מי אני נהיה/ת לידם."
    ],
      [
      "היום אני בודק מי אני נהיה/ת לידם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת לעצמי בתוך קשר כזה?\n[כאן אני כותב]",
      "האם אני קטן/ה, דרוך/ה, מבולבל/ת?\n[כאן אני כותב]",
      "מי אני רוצה להיות בקשר?\n[כאן אני כותב]"
    ],
      [
      "איך אני מדבר/ת לעצמי בתוך קשר כזה?\n[כאן אני כותב]",
      "האם אני קטן/ה, דרוך/ה, מבולבל/ת?\n[כאן אני כותב]",
      "מי אני רוצה להיות בקשר?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קשר אמור להרחיב אותי, לא לצמצם."
    ],
      [
      "סגירה",
      "קשר אמור להרחיב אותי, לא לצמצם."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת תכונה אחת שלי שנעלמת בקשרים כאלה.",
      "אני כותב/ת תכונה אחת שלי שנעלמת בקשרים כאלה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "הפחד מנטישה שמוביל לבחירה לא נכונה",
    opening: localizedGenderNode(
      [
      "היום אני נוגע בפחד בלי לתת לו לבחור במקומי."
    ],
      [
      "היום אני נוגע בפחד בלי לתת לו לבחור במקומי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הפחד הכי חזק אם אהיה לבד?\n[כאן אני כותב]",
      "איך הוא משפיע על הבחירות שלי?\n[כאן אני כותב]",
      "איזו אמת עדינה קיימת גם אם הפחד שם?\n[כאן אני כותב]"
    ],
      [
      "מה הפחד הכי חזק אם אהיה לבד?\n[כאן אני כותב]",
      "איך הוא משפיע על הבחירות שלי?\n[כאן אני כותב]",
      "איזו אמת עדינה קיימת גם אם הפחד שם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פחד הוא רגש — לא מצפן."
    ],
      [
      "סגירה",
      "פחד הוא רגש — לא מצפן."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת: “פחד, ראיתי אותך. אני בוחר/ת לאט.”",
      "אני אומר/ת: “פחד, ראיתי אותך. אני בוחר/ת לאט.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "מה אני באמת בוחר/ה בקשר",
    opening: localizedGenderNode(
      [
      "היום אני מנסח צרכים, לא פנטזיות."
    ],
      [
      "היום אני מנסח צרכים, לא פנטזיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "שלושה צרכים בסיסיים בקשר עבורי:\n[כאן אני כותב]",
      "האם הם מתקיימים בדפוס הישן?\n[כאן אני כותב]",
      "מה חשוב לי יותר מריגוש?\n[כאן אני כותב]"
    ],
      [
      "שלושה צרכים בסיסיים בקשר עבורי:\n[כאן אני כותב]",
      "האם הם מתקיימים בדפוס הישן?\n[כאן אני כותב]",
      "מה חשוב לי יותר מריגוש?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "צרכים ברורים מגנים על הלב."
    ],
      [
      "סגירה",
      "צרכים ברורים מגנים על הלב."
    ]
    ),
    action: localizedGenderNode(
      "אני שומר/ת רשימת צרכים במקום נגיש.",
      "אני שומר/ת רשימת צרכים במקום נגיש."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "משיכה ככאב, לא כגורל",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה להאמין ש“ככה אני”."
    ],
      [
      "היום אני מפסיק/ה להאמין ש“ככה אני”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אמרתי לעצמי על המשיכה שלי לאורך השנים?\n[כאן אני כותב]",
      "איך זה מרגיש לחשוב שזו לא גזירת גורל?\n[כאן אני כותב]",
      "מה אפשרי אם אלמד לבחור אחרת?\n[כאן אני כותב]"
    ],
      [
      "מה אמרתי לעצמי על המשיכה שלי לאורך השנים?\n[כאן אני כותב]",
      "איך זה מרגיש לחשוב שזו לא גזירת גורל?\n[כאן אני כותב]",
      "מה אפשרי אם אלמד לבחור אחרת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא מקולקל/ת — אני לומד/ת."
    ],
      [
      "סגירה",
      "אני לא מקולקל/ת — אני לומד/ת."
    ]
    ),
    action: localizedGenderNode(
      "אני מחליף/ה משפט אחד מגביל במשפט מאפשר.",
      "אני מחליף/ה משפט אחד מגביל במשפט מאפשר."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "עצירה לפני הבחירה הבאה",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת האטה."
    ],
      [
      "היום אני מתרגל/ת האטה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני בדרך כלל ממהר/ת לקשר?\n[כאן אני כותב]",
      "מה קורה אם אני מחכה עוד קצת?\n[כאן אני כותב]",
      "איזה סימן אדום אני נוטה להתעלם ממנו?\n[כאן אני כותב]"
    ],
      [
      "איך אני בדרך כלל ממהר/ת לקשר?\n[כאן אני כותב]",
      "מה קורה אם אני מחכה עוד קצת?\n[כאן אני כותב]",
      "איזה סימן אדום אני נוטה להתעלם ממנו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בחירה טובה צריכה זמן."
    ],
      [
      "סגירה",
      "בחירה טובה צריכה זמן."
    ]
    ),
    action: localizedGenderNode(
      "היום אני לא ממהר/ת לשום החלטה רגשית.",
      "היום אני לא ממהר/ת לשום החלטה רגשית."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבנות משיכה חדשה",
    opening: localizedGenderNode(
      [
      "היום אני מגדיר משיכה אחרת."
    ],
      [
      "היום אני מגדיר משיכה אחרת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "לאילו תכונות אני רוצה לפתח משיכה?\n[כאן אני כותב]",
      "איך מרגיש קשר שמכבד אותי?\n[כאן אני כותב]",
      "איזה ערך יוביל אותי מעכשיו?\n[כאן אני כותב]"
    ],
      [
      "לאילו תכונות אני רוצה לפתח משיכה?\n[כאן אני כותב]",
      "איך מרגיש קשר שמכבד אותי?\n[כאן אני כותב]",
      "איזה ערך יוביל אותי מעכשיו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "משיכה ניתנת ללמידה מחדש."
    ],
      [
      "סגירה",
      "משיכה ניתנת ללמידה מחדש."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת ערך אחד לשבוע הקרוב.",
      "אני בוחר/ת ערך אחד לשבוע הקרוב."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה והתיכולות לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מסכם בלי לשפוט."
    ],
      [
      "היום אני מסכם בלי לשפוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבנתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה אני מפסיק/ה לעשות בקשרים?\n[כאן אני כותב]",
      "משפט חזרה לימים של בלבול:\n[כאן אני כותב]"
    ],
      [
      "מה הבנתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה אני מפסיק/ה לעשות בקשרים?\n[כאן אני כותב]",
      "משפט חזרה לימים של בלבול:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא נמשך/ת למה שפוגע בי —",
      "אני לומד/ת להקשיב למה שמכבד אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא נמשך/ת למה שפוגע בי —",
      "אני לומד/ת להקשיב למה שמכבד אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת בחירה חדשה (כתיבה / שיחה בטוחה / סדר פנימי).",
      "פעולה אחת שמסמלת בחירה חדשה (כתיבה / שיחה בטוחה / סדר פנימי)."
    ),
  },
].map(buildNormalizedDay);

export const repeatedAttractionToDestructivePartnersBlueprintHe = buildNormalizedPilotBlueprint({
  id: "repeated_attraction_to_destructive_partners_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "repeated_attraction_to_destructive_partners",
  category: "general",
  journeyName: {
    he: "משיכה חוזרת לבני/בנות זוג הרסניים",
    en: "Repeated Attraction to Destructive Partners",
    es: "Atracción Repetida por Parejas Destructivas",
  },
  days,
});

export default repeatedAttractionToDestructivePartnersBlueprintHe;
